import React from "react"
import "@fontsource/roboto"
import theme from '../styles/theme'
import { ChakraProvider } from '@chakra-ui/react'
import AuthProvider from "./AuthProvider"
import AdminProvider from "./AdminProvider"
import { QueryClient, QueryClientProvider } from 'react-query'

type Props = { children: React.ReactNode }

const Providers: React.FC<Props> = ({ children }): JSX.Element => {
  const queryClient = new QueryClient()

  return (
    <React.Fragment>
      <ChakraProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <AdminProvider>
              {children}
            </AdminProvider>
          </AuthProvider>
        </QueryClientProvider>
      </ChakraProvider>
    </React.Fragment>
  )
}

export default Providers